<script lang="ts" setup>
import Section3List from '@/pages/membership/components/Section3List.vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const refSectionBottom = ref()

const initAni = () => {
  const gTimeLine = gsap.timeline()

  gTimeLine.fromTo(".section3__inner", {
    scale: 0.4
  }, {
    scale: 1.2,
    scrollTrigger: {
      trigger: '.section3__inner',
      start: '-=55%', // 从屏幕中间开始固定
      end: () => "+=250%",
      scrub: true,
      pin: true,
      pinSpacing: true,
      // invalidateOnRefresh: true,
    }
  })

  // gTimeLine.to(".section3__inner", {
  //   scale: 0.4,
  //   ease: "none",
  //   duration: 1.6
  // }, ">").fromTo(".section3__inner .section3__pic__box", {
  //   scale: 1
  // }, {
  //   scale: 1.15,
  //   ease: "none",
  //   duration: 1.6
  // }, ">").to(".section3__inner", {
  //   duration: .6
  // })
}

// onMounted(() => {
//   useImagesLoaded('.section3__inner img').then(initAni)
// })
defineExpose({
  initAni
});
</script>

<template>
  <section class="section3">
    <div class="section3__top">
      <div class="section3__inner">
        <div class="section3__pic">
          <div class="section3__pic__left section3__pic__item">
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg1.jpg" />
            </figure>
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg2.jpg" />
            </figure>
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg3.jpg" />
            </figure>
          </div>
          <div class="section3__pic__center section3__pic__item">
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg4.jpg" />
            </figure>
            <figure class="section3__pic__box center_pic">
              <Nimg src="./images/membership/bg5.jpg" />
            </figure>
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg6.jpg" />
            </figure>
          </div>
          <div class="section3__pic__right section3__pic__item">
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg7.jpg" />
            </figure>
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg8.jpg" />
            </figure>
            <figure class="section3__pic__box">
              <Nimg src="./images/membership/bg9.jpg" />
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="section3__bottom" ref="refSectionBottom">
      <div class="section3__intro">
        <div class="section3__intro__top">
          <div class="section3__intro__top__icon">
            <svg-icon name="icon-logo" />
          </div>
          <div class="section3__intro__top__title">會員權益</div>
        </div>
        <div class="section3__intro__title">
          member<br />
          benefits
        </div>
      </div>
      <Section3List />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section3 {
  // margin-top: toRem(100);
  z-index: -1 !important;
  width: 100%;

  :deep(.pin-spacer) {
    pointer-events: none;
    overflow: hidden !important;
  }

  &__intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: toRem(120);
    text-align: center;
    color: $color-white-1;

    @include max-media(480) {
      margin-bottom: toRem(56);
    }

    &__top {
      display: flex;
      flex-direction: column;
      align-items: center;

      &__icon {
        width: toRem(114);
        height: toRem(41);
        margin-bottom: toRem(23);

        @include max-media(480) {
          width: toRem(66);
          height: toRem(24);
        }
      }

      &__title {
        font-size: toRem(28);
        font-weight: 500;
        line-height: 1.3;

        @include max-media(480) {
          font-size: toRem(22);
          margin-bottom: toRem(23);
        }
      }
    }

    &__title {
      font-size: toRem(120);
      font-family: $font-TextaAlt;
      font-weight: 500;
      line-height: 0.8;
      letter-spacing: toRem(-2.4);

      @include max-media(480) {
        font-size: toRem(60);
      }
    }
  }

  // margin-top: -100vh !important;
  &__inner {
    // margin-top: -50vh;
    // top: -50vh;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    transform-origin: center;
  }

  &__bottom {
    position: relative;
    z-index: 5;
    padding-top: 100vh;
    padding-bottom: toRem(400);
    padding-left: toRem(24);
    padding-right: toRem(24);

    @include max-media(960) {
      padding-bottom: toRem(100);
    }
  }

  &__pic {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 300vh;
    display: flex;
    justify-content: space-between;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
    }

    &__item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      width: 100vw;
      height: 300vh;
      background-color: $color-black-1;
    }

    &__box {
      width: 100%;
      height: 100vh;
      background-color: green;
      margin-top: toRem(56);
      margin-bottom: toRem(56);

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__left,
    &__right {
      transform: translateY(-100px);
      padding-left: toRem(56);
      padding-right: toRem(56);
    }

    &__center {
      margin-right: toRem(-2);
      margin-left: toRem(-2);
    }
  }
}
</style>

<style></style>
